import AccountCardPreviewFile from './AccountCardPreviewFile';

export default AccountCardPreviewFile;
